import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/commission-plans/profile/loading';

export const Route = createFileRoute('/_private/settings/commission-plans/$id')({
  pendingComponent: Loading,
});
